module.exports = {
	ok: gettext('Ok'),
	cancel: gettext('Cancel'),
	guideStarModalTitle: gettext('Use GuideStar')
};



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/surveys/strings.js